import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class ChatReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const isChatRoute = (r: ActivatedRouteSnapshot) =>
      r.routeConfig?.path === '' || r.routeConfig?.path === 'session/:id';

    if (isChatRoute(future) && isChatRoute(curr)) {
      return true;
    }

    return super.shouldReuseRoute(future, curr);
  }
}
